<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>使用者管理</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-5" v-if="permisionInspectManager">
          <h4 class="col-md-4 fontSize20">搜尋關鍵字:</h4>
          <input
            v-model="inputFilter"
            type="text"
            required="required"
            class="inputstyle col-md-4 fontSize14 selectstyle"
            placeholder="姓名、權限"
          />
          <button
            @click="searchWithFilter"
            type="button"
            class="mybtnstyle btn-success selectstyle"
          >
            搜尋
          </button>
        </div>
        <div class="col-md-7">
          <div class="col-md-9 selectstyle">
            <h4 class="col-md-5">
              <i class="fa fa-user"></i>
              使用者總數:
            </h4>
            <h4 class="red_textcolor col-md-2">{{ managerList.length }}</h4>
            <router-link
              class="mybtnstyle btn-dark white_textcolor"
              :to="'/serviceMain/addManager'"
              v-if="permisionModifyManager"
            >
              新增使用者
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="x_content move_down">
      <div class="table-responsive">
        <table class="table table-striped jambo_table bulk_action word_center">
          <thead>
            <tr class="headings">
              <th class="column-title word_center">序號</th>
              <th class="column-title word_center">姓名</th>
              <th class="column-title word_center">單位名稱</th>
              <th class="column-title word_center">電話</th>
              <th class="column-title word_center">公司客服電話 - 編號</th>
              <th class="column-title word_center">職位</th>
              <th class="column-title no-link last word_center">
                <span class="nobr">檢視</span>
              </th>
            </tr>
          </thead>
          <tbody v-if="managerList.length > 0">
            <template v-for="(manager, index) in filter_list">
              <tr
                class="pointer"
                :class="getManagerItemClassObj"
                :key="manager.id"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ manager.managerName }}</td>
                <td>{{ manager.department }}</td>
                <td>{{ manager.phone }}</td>
                <td>
                  {{ manager.servicePhone }} - {{ manager.serviceNumber }}
                </td>
                <td>{{ manager.positionName }}</td>
                <td class="last">
                  <router-link
                    class="red_textcolor"
                    :to="{ name: 'ManagerDetail', params: { id: manager.id } }"
                    v-if="permisionInspectManager"
                  >
                    檢視
                  </router-link>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import managerService from '@/API/managerService'
import { mapActions, mapGetters } from 'vuex'
import { getAdminAuthorization } from '../../assets/js/tool/adminAuth'

export default {
  name: 'ManagerList',
  data() {
    return {
      fullPage: false,
      loader: null,
      inputFilter: '',
      filterValue: '',
    }
  },
  computed: {
    ...mapGetters({
      managerList: 'managerStore/getManagerList',
    }),
    filter_list() {
      return this.managerList.filter((manager) => {
        return Object.keys(manager).some(
          (key) =>
            manager[key] !== null &&
            manager[key].toString().includes(this.filterValue),
        )
      })
    },
  },
  methods: {
    permisionInspectManager() {
      return getAdminAuthorization('userManagement') >= 1
    },
    permisionModifyManager() {
      return getAdminAuthorization('userManagement') === 2
    },
    ...mapActions({
      fetchManagerList: 'managerStore/fetchManagerList',
    }),
    showLoading() {
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
    },
    searchWithFilter() {
      this.filterValue = this.inputFilter
    },
    getManagerItemClassObj(index) {
      return {
        even: index % 2 === 0,
        odd: index % 2 !== 0,
      }
    },
  },
  async mounted() {
    await this.showLoading()
    await this.fetchManagerList()
      .then(() => {
        this.loader.hide()
      })
      .catch((e) => {
        console.log(e)
        this.loader.hide()
      })
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/manager/ManagerList.vue